import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import { OrderLayoutTableFilter } from '../../../OrderLayout/OrderTable/useOrderLayoutTableLogic/types'

export type ServedOrderTDTy = {
    tableData: { [fieldName: string]: any }[]
    selectedProducts: TwinDictionary
    dictPosTableData: TwinDictionary
    filteredTableData?: { [fieldName: string]: any }[]
    filters: OrderLayoutTableFilter
    showRestoreButton: boolean
}

export interface TypeFieldSearchTy {
    0: 'reference'
    1: 'code_bar',
}
export const typeFieldSearchTyInversed = {
    'reference': 0,
    'code_bar': 1,
}
export const typeFieldSearchTy = {
    0: 'reference',
    1: 'code_bar',
}
export const typeFieldSearchCompleteTy = {
    0: ['reference', 'secondaryReference'],
    1: ['code_bar', 'custom_code_bar'],
}

export type TypeFieldSearchTyKeys = keyof TypeFieldSearchTy
export type TypeFieldSearchTyKeysInversed = keyof typeof typeFieldSearchTyInversed

export type SellOrderPrepareLocalStorageTy = {
    tableData: { [fieldName: string]: any }[]
    dictPosTableData: TwinDictionary
}